// DailyBarChart.js
import React from 'react';
import Chart from 'react-apexcharts';

function DailyBarChart({ dailyData }) {
  // Prepare data for ApexCharts
  const categories = dailyData.map(day => day.date);
  const seriesData = dailyData.map(day => {
    // Convert duration "xh ym zs" into total minutes
    const [h, m, s] = day.duration
      .match(/(\d+)h (\d+)m (\d+)s/)
      .slice(1)
      .map(Number);
    return h * 60 + m + s / 60; // total minutes
  });

  const series = [
    {
      name: 'Hours',
      data: seriesData,
    },
  ];

  const options = {
    chart: {
      type: 'bar',
      height: 300,
      toolbar: { show: false },
    },
    plotOptions: {
      bar: {
        borderRadius: 6,
        horizontal: false,
        columnWidth: '50%',
      },
    },
    dataLabels: { enabled: false },
    xaxis: {
      categories,
    },
    yaxis: {
      min: 0,
      labels: {
        formatter: (val) => {
          const h = Math.floor(val / 60);
          const m = Math.round(val % 60);
          return `${h}h ${m}m`;
        },
      },
      title: {
        text: 'Hours',
      },
    },
    tooltip: {
      y: {
        formatter: (val) => {
          const h = Math.floor(val / 60);
          const m = Math.round(val % 60);
          return `${h}h ${m}m`;
        },
      },
    },
    fill: {
      type: 'gradient',
      gradient: {
        shade: 'dark',
        type: 'vertical',
        shadeIntensity: 0.7,
        gradientToColors: ['#ff9a64ff'], // bright green gradient
        inverseColors: false,
        opacityFrom: 0.9,
        opacityTo: 0.9,
        stops: [0, 100],
      },
    },
    colors: ['#e75348ff'], // fallback dark green
  };

  return <Chart options={options} series={series} type="bar" height={300} />;
}

export default DailyBarChart;
